import { IDocumentType, IReferentialBase, IStatus } from "@/interfaces/referential";
import { ajaxCall } from "@/tools/axios-wrapper";
import BaseApi from "./base-api";

class ReferentialsApi extends BaseApi<IReferentialBase> {
  async getStatuses() {
    return await ajaxCall.get<Array<IStatus>>(this.apiUrl, {
      urlParameter: [this.objectName, "status"]
    });
  }

  async getDocumentTypes() {
    return await ajaxCall.get<Array<IDocumentType>>(this.apiUrl, {
      urlParameter: [this.objectName, "documentType"]
    });
  }
}

export default new ReferentialsApi("Referentials", "referential");
